import { render, staticRenderFns } from "./KycApproved.vue?vue&type=template&id=2fc78c2d&"
import script from "./KycApproved.vue?vue&type=script&lang=js&"
export * from "./KycApproved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports